<template>
  <div class="overflow-auto flex flex-col items-stretch justify-start p-10">
    <div class="flex flex-col items-stretch justify-start gap-10">
      <div class="flex flex-col items-center justify-start gap-5">
        <svg-icon iconName="mail-icon" className="text-blueG0 !w-15 !h-15"></svg-icon>
        <div class="text-base text-center text-darkBlueG0 font-bold">
          {{ $t(title) }}
        </div>
        <div class="text-sm text-center whitespace-pre-line" v-html="$t(desc)" />
      </div>
      <div class="flex flex-wrap items-center justify-center gap-2.5">
        <el-button v-if="secondaryButtonOnClick" class="white_button min-w-55 !m-0" @click="secondaryButtonOnClick">
          {{ $t(secondaryButtonLabel) }}
        </el-button>
        <el-button v-if="primaryButtonOnClick" class="blue_button min-w-55 !m-0" @click="primaryButtonOnClick">
          {{ $t(primaryButtonLabel) }}
        </el-button>
      </div>
    </div>
    <el-divider v-if="lists.length > 0" class="my-10 flex-none"></el-divider>
    <RegisterCollapse v-if="lists.length > 0" :lists="lists" />
  </div>
</template>

<script>
import RegisterCollapse from './RegisterCollapse.vue';

export default {
  components: { RegisterCollapse },
  name: 'SuccessForm',
  props: {
    title: { type: String, default: '' },
    desc: { type: String, default: '' },
    // { name: '1',title:'', desc: '', slot: <Component />? }
    lists: { type: Array, default: () => [] },
    primaryButtonLabel: { type: String, default: '' },
    primaryButtonOnClick: { type: [Function, null], default: null },
    secondaryButtonLabel: { type: String, default: '' },
    secondaryButtonOnClick: { type: [Function, null], default: null }
  }
};
</script>
